export const getIntAttribute = (elem: SVGSVGElement, attributeName: string): number =>
  parseInt(elem.getAttribute(attributeName) || '-1', 10);

export const getRelativeCursorPosition = (
  event: any,
  parentNode: any,
  scaleFactor: number
): { clientX: number; clientY: number } => {
  const cursorPosition = { clientX: 0, clientY: 0 };

  if (!parentNode || !event) {
    return cursorPosition;
  }

  const { left, top } = parentNode.getBoundingClientRect();

  if (event.changedTouches?.length) {
    cursorPosition.clientX = (event.changedTouches[0].clientX - left) * scaleFactor;
    cursorPosition.clientY = (event.changedTouches[0].clientY - top) * scaleFactor;
  } else if (event.touches?.length) {
    cursorPosition.clientX = (event.touches[0].clientX - left) * scaleFactor;
    cursorPosition.clientY = (event.touches[0].clientY - top) * scaleFactor;
  } else {
    cursorPosition.clientX = (event.clientX - left) * scaleFactor;
    cursorPosition.clientY = (event.clientY - top) * scaleFactor;
  }

  return cursorPosition;
};

export const isElementClicked = (
  element: any,
  cursorPosition: { clientX: number; clientY: number },
  tolerance: { horizontal: number; vertical: number }
): boolean => isWhithinTapRange(element, cursorPosition, tolerance);

export const getElementCoordinates = (elem): { x: number; y: number } => {
  const x = getIntAttribute(elem, 'x');
  const y = getIntAttribute(elem, 'y');

  return { x, y };
};

const isWhithinTapRange = (
  elem: any,
  cursorPosition: { clientX: number; clientY: number },
  tolerance: { horizontal: number; vertical: number }
): boolean => {
  const { x, y } = getElementCoordinates(elem);
  const width = getIntAttribute(elem, 'width');
  const height = getIntAttribute(elem, 'height');

  const { clientX, clientY } = cursorPosition;
  const { horizontal, vertical } = tolerance;

  const inHrange = clientX >= x - horizontal && clientX <= x + width + horizontal;
  const inVrange = clientY >= y - vertical && clientY <= y + height + vertical;

  return inHrange && inVrange;
};

export const scrollIntoView = (id: string) => {
  document
    .getElementById(id)
    ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
};
